export var FolderableModal;
(function (FolderableModal) {
    FolderableModal["RISK_PROFILE"] = "risk-profile";
    FolderableModal["HYPOTHETICAL"] = "hypothetical";
    FolderableModal["ANALYSIS_PLAN"] = "analysis-plan";
    FolderableModal["FUND_CHART"] = "fund-chart";
    FolderableModal["SCATTER_PLOT"] = "scatter-plot";
    FolderableModal["TECH_CHART"] = "tech-chart";
})(FolderableModal || (FolderableModal = {}));
